interface UserMenuElements {
  toggle: HTMLButtonElement | null;
  content: HTMLElement | null;
}

export class UserMenuWidget {
  private elements: UserMenuElements;
  private isOpen = false;
  private readonly DESKTOP_BREAKPOINT = 992;

  constructor() {
    this.elements = {
      toggle: document.getElementById('user-menu-toggle') as HTMLButtonElement | null,
      content: document.getElementById('user-menu-content'),
    };
  }

  public init(): void {
    if (!this.elements.toggle || !this.elements.content) return;

    this.bindEvents();
    this.setupResizeListener();
  }

  // ------------------------
  // Events
  // ------------------------

  private bindEvents(): void {
    this.elements.toggle!.addEventListener('click', (e) => {
      e.preventDefault();
      this.toggle();
    });

    // Закрытие по Esc
    document.addEventListener('keydown', (e: KeyboardEvent) => {
      if (e.key === 'Escape' && this.isOpen) {
        this.close();
      }
    });

    // Закрытие по клику вне меню
    document.addEventListener('click', (e: MouseEvent) => {
      if (!this.isOpen) return;

      const target = e.target as Node;
      if (!this.elements.toggle!.contains(target) && !this.elements.content!.contains(target)) {
        this.close();
      }

      if (this.elements.content!.contains(target)) {
        this.close();
      }
    });
  }

  private setupResizeListener(): void {
    let resizeTimer: number;

    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(() => {
        if (window.innerWidth < this.DESKTOP_BREAKPOINT && this.isOpen) {
          this.close();
        }
      }, 150);
    });
  }

  // ------------------------
  // Menu logic
  // ------------------------

  private toggle(): void {
    if (this.isOpen) {
      this.close();
    } else {
      this.open();
    }
  }

  private open(): void {
    if (this.isOpen) return;
    this.isOpen = true;

    this.elements.content!.classList.remove('d-none');
    this.elements.content!.classList.add('d-block');
    this.elements.toggle!.setAttribute('aria-expanded', 'true');
  }

  private close(): void {
    if (!this.isOpen) return;
    this.isOpen = false;

    this.elements.content!.classList.add('d-none');
    this.elements.content!.classList.remove('d-block');
    this.elements.toggle!.setAttribute('aria-expanded', 'false');
  }
}
